import { Youtube, Play } from 'lucide-react';

const MadeNotMadeUp = () => {
  const episodes = [
    {
      title: "Episode 1: The Founder's Journey",
      description: "Meet the visionary behind a successful D2C brand and learn about their entrepreneurial journey from ideation to scaling.",
      thumbnail: "https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=2074",
      duration: "24:30",
      views: "15K"
    },
    {
      title: "Episode 2: Building a Tech Startup",
      description: "A deep dive into the world of tech entrepreneurship with a young founder who disrupted the education sector.",
      thumbnail: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=2070",
      duration: "28:15",
      views: "12K"
    },
    {
      title: "Episode 3: Social Impact Ventures",
      description: "Discover how entrepreneurs are creating positive social change while building sustainable businesses.",
      thumbnail: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?q=80&w=2070",
      duration: "22:45",
      views: "18K"
    },
    {
      title: "Episode 4: From College to Company",
      description: "Student entrepreneurs share their stories of balancing academics while launching their startups.",
      thumbnail: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069",
      duration: "26:00",
      views: "20K"
    },
  ];

  return (
    <div className="pt-20" data-testid="made-not-made-up-page">
      <section className="section-padding bg-gradient-to-b from-black to-[#121212]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-500 mb-4">KAROBAR ORIGINALS</p>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter uppercase mb-6" style={{ fontFamily: 'Open Sans' }}>MADE, NOT MADE UP</h1>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">Authentic stories from real entrepreneurs. No filters, no fluff—just genuine insights from founders who've been there, done that.</p>
          </div>

          <div className="glass-card p-8 lg:p-12 mb-16">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <Youtube className="w-12 h-12 text-gold-500 mb-6" />
                <h2 className="text-3xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>ABOUT THE SHOW</h2>
                <p className="text-gray-400 text-lg leading-relaxed mb-6">
                  <span className="text-gold-500 font-bold">Made, Not Made Up</span> is KAROBAR's flagship YouTube series that brings you face-to-face with successful entrepreneurs, innovators, and changemakers. Each episode dives deep into their real journeys, challenges, failures, and the lessons they learned along the way.
                </p>
                <p className="text-gray-400 leading-relaxed mb-6">
                  From bootstrapped startups to venture-backed unicorns, we cover it all. No scripted narratives, no sugar-coating—just raw, authentic conversations that inspire and educate aspiring entrepreneurs.
                </p>
                <a 
                  href="https://youtube.com/@karobar" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="btn-primary inline-flex items-center space-x-2"
                  data-testid="subscribe-youtube-button"
                >
                  <Youtube size={20} />
                  <span>SUBSCRIBE ON YOUTUBE</span>
                </a>
              </div>
              <div className="relative">
                <img 
                  src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070" 
                  alt="Made Not Made Up" 
                  className="w-full h-96 object-cover glass-card"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-20 h-20 bg-gold-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform cursor-pointer">
                    <Play className="text-black" size={32} fill="black" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-3xl font-black mb-8 text-center" style={{ fontFamily: 'Open Sans' }}>LATEST EPISODES</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {episodes.map((episode, index) => (
                <div key={index} className="glass-card overflow-hidden group" data-testid={`episode-${index}`}>
                  <div className="relative h-56 overflow-hidden">
                    <img src={episode.thumbnail} alt={episode.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                      <div className="w-16 h-16 bg-gold-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                        <Play className="text-black" size={24} fill="black" />
                      </div>
                    </div>
                    <div className="absolute top-4 right-4 bg-black/80 backdrop-blur-sm px-3 py-1 text-xs font-semibold">
                      {episode.duration}
                    </div>
                    <div className="absolute bottom-4 left-4 bg-black/80 backdrop-blur-sm px-3 py-1 text-xs font-semibold">
                      {episode.views} views
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-black mb-3 group-hover:text-gold-500 transition-colors" style={{ fontFamily: 'Open Sans' }}>{episode.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{episode.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-16 text-center">
            <a 
              href="https://youtube.com/@karobar" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-gold-500 hover:text-gold-400 font-semibold text-lg"
              data-testid="view-all-episodes-link"
            >
              VIEW ALL EPISODES ON YOUTUBE →
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MadeNotMadeUp;